module.exports = __webpack_public_path__ + "static/media/classes-active.60c04bda.svg";